import React from 'react'
import * as Displays from 'support/displays'

export function FieldLabel ({ fromName = 'start_at', toName = 'end_at' }) {
  return (
    <>
      <Displays.Date name={fromName}/> - <Displays.Date name={toName}/>
    </>
  )
}

export default FieldLabel
